<div class="talent-page-wrapper consent-wrapper" *ngIf="!hasAgreed">
  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoading">
    <app-loader></app-loader>
  </div>
  <!-- Standardized Brand Header -->
  <header class="talent-header">
      <div class="logo-section">
          <ng-container *ngIf="logoUrl; else defaultLogo">
              <img [src]="logoUrl" alt="Company Logo" style="max-height: 40px; max-width: 150px; object-fit: contain; margin-right: 10px;">
          </ng-container>
          <ng-template #defaultLogo>
              <div class="logo-icon">
                  <i class="bi bi-cpu-fill"></i>
              </div>
          </ng-template>
          <div class="logo-text">
              <h6>{{ organizationName || 'AI Interview Platform' }}</h6>
              <p>SYSTEM SETUP</p>
          </div>
      </div>
      <div class="secure-badge">
          <span class="dot"></span>
          Secure AI session
      </div>
  </header>

  <div class="consent-page-container">
    <div class="consent-card">
      <div class="consent-header">
        <div class="icon-wrapper">
          <i class="bi bi-shield-check"></i>
        </div>
        <h2>AI Proctoring Readiness</h2>
        <p>Please review the proctoring rules before starting your interview.</p>
      </div>

      <div class="consent-body">
        <div class="rules-section">
          <h3>Proctoring Rules &amp; Guidelines</h3>
          <ul class="rules-list">
            <li><i class="bi bi-x-circle-fill"></i> No other face should be visible in the frame.</li>
            <li><i class="bi bi-x-circle-fill"></i> Avoid looking away from the screen frequently.</li>
            <li><i class="bi bi-x-circle-fill"></i> Do not switch tabs or minimize the browser window.</li>
            <li><i class="bi bi-x-circle-fill"></i> Ensure your face is centered and clearly visible.</li>
            <li><i class="bi bi-x-circle-fill"></i> Entire interview will be recorded. Make sure you are in a private place.</li>
            <li><i class="bi bi-x-circle-fill"></i> Once the interview starts, don't press any key or click on any button — it will count as a violation.</li>
            <li><i class="bi bi-x-circle-fill"></i> Don't refresh the page — the interview will be auto submitted.</li>
          </ul>
        </div>

        <label class="agreement-section">
          <input type="checkbox" [(ngModel)]="termsAccepted">
          <span>I agree to the AI proctoring rules and live monitoring.</span>
        </label>

        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
      </div>

      <div class="consent-footer">
        <button class="btn-primary" (click)="accept()" [disabled]="!termsAccepted">
          Continue to Share Screen <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>